import { useQuery } from "@tanstack/react-query";
import { getAssetReplacement } from "../../../resource/bff";

export const useGetAssetReplacementAsync = () => {
  const { isLoading, error, data, isFetching, refetch, isRefetching } =
    useQuery(
      ["userReplacements"],
      () => getAssetReplacement().then((res: any) => res),
      { cacheTime: Infinity }
    );
  return {
    isLoading,
    isRefetching,
    error,
    data,
    refetch,
    isFetching,
  };
};
